import { storage } from '@/plugins/ionic-storage';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('app', () => {
  const isFirstLogin = ref(true); // 是否是第一次登录
  const loaded = ref(false); // 是否加载完成 
  const lang = ref(navigator.language || 'zh-CN'); // 语言

  const setInitialLogin = (val: boolean) => {
    isFirstLogin.value = val;
    storage.set('isFirstLogin', val);
  };

  const setLang = (val: string) => {
    lang.value = val;
    storage.set('IMI18n', val);
  }

  // 同步登录状态，从本地存储中获取
  const syncLogin = async () => {
    const data = await storage.get('isFirstLogin');
    loaded.value = true;
    if (data === false || data === true) isFirstLogin.value = data;
  };

  const syncLang = async () => {
    const data = await storage.get('IMI18n');
    if (data) lang.value = data;
  }

  setTimeout(() => {
    loaded.value = true;
  }, 20);

  return {
    isFirstLogin,
    loaded,
    // syncLogin,
    syncLang,
    setInitialLogin,
    lang,
    setLang
  };
});
